import { defineChart } from '@/charts'
import { tooltip } from '@/composables/useChart/theme'

type Params = [imports: Import[], country?: string]

/**
 * Create the world bar chart options.
 */
export default defineChart<Params>((imports, selectedCountry) => {
    const { meta } = useMeta()
    const format = importsValueFomatter()

    let prevValue = 0

    return {
        grid: {
            top: '2%',
            left: 0,
            bottom: '5%',
            right: 0
        },
        yAxis: {
            type: 'value',
            show: false
        },
        xAxis: {
            type: 'category',
            show: false
        },
        series: meta.products.flatMap(({ name, color, id, icon }) => {
            return {
                type: 'bar',
                barCategoryGap: '15%',
                tooltip: {
                    formatter(params) {
                        return tooltip(
                            '',
                            String(params.seriesName),
                            format(Number(params.value))
                        )
                    }
                },
                stack: 'stack',
                name: name,
                barWidth: 80,
                itemStyle: {
                    color
                },
                label: {
                    position: 'bottom',
                    align: 'left',
                    verticalAlign: 'bottom',
                    offset: [75, 0],
                    backgroundColor: 'transparent',
                    padding: [0, 0, 0, 10],
                    formatter(params) {
                        return format(Number(params.value))
                    },
                    show: true
                },
                labelLine: {
                    distance: 20,
                    show: true
                },
                data: imports
                    .filter(({ country }) => country === selectedCountry)
                    .map(({ country, products }) => {
                        const value = products
                            .filter(p => p.product_id === id)
                            .reduce((a, b) => a + (b.import_value || 0), 0)

                        return {
                            name: country,
                            value: value,
                            label: {
                                show: value > 0
                            }
                        }
                    }),
                markPoint: {
                    z: 1000,
                    itemStyle: {
                        color
                    },
                    silent: true,
                    data: imports
                        .filter(({ country }) => country === selectedCountry)
                        .flatMap(({ products, country }) => {
                            const value = products
                                .filter(p => p.product_id === id)
                                .reduce((a, b) => a + (b.import_value || 0), 0)
                            prevValue += value

                            return [
                                {
                                    yAxis: prevValue - value / 2,
                                    x: '25%',
                                    symbolSize: value > 0 ? 35 : 0,
                                    symbol: 'circle',
                                    name: country
                                },
                                {
                                    name: country,
                                    yAxis: prevValue - value / 2,
                                    x: '25%',
                                    symbolSize: value > 0 ? 20 : 0,
                                    symbol: `image://${icon}`
                                }
                            ]
                        })
                }
            }
        })
    }
})
